import moment from 'moment';
export const yearsIn: number = moment().diff(moment('19981001'), 'years');

export default yearsIn;
